import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React, { Component } from 'react';
import { Infractions } from './Infractions';
import './Sanction.js.css';

export class Sanction extends Component {
    constructor(props) {
        super(props);
        this.state = { afficherInfractions: false };
        this.definirAfficherInfractions = this.definirAfficherInfractions.bind(this);
    }

    definirAfficherInfractions = () => {
        this.setState({ afficherInfractions: !this.state.afficherInfractions });
    }

    render() {
        const { afficherInfractions } = this.state;
        const { date, nombreInfractions, infractions } = this.props.sanction;

        return (
            <>
                <TableRow>
                    <TableCell size='small'>
                        <IconButton
                            size="small"
                            onClick={this.definirAfficherInfractions}
                        >
                            {afficherInfractions ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell>{date}</TableCell>
                    <TableCell>{nombreInfractions}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell className='infractions' colSpan={3}>
                        <Collapse in={afficherInfractions} timeout="auto" unmountOnExit>
                            <Infractions key={date + nombreInfractions} infractions={infractions} />
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        );
    }
}
